import React, { useEffect, createElement } from 'react';
const VISUALIZER_BASE_URL = 'https://rrimcqoixwqgvwgbbxpz.supabase.co/storage/v1/object/public/product-visualizer-resources/';
const VISUALIZER_CSS_URL = `${VISUALIZER_BASE_URL}latest/index.css`;
const VISUALIZER_SCRIPT_URL = `${VISUALIZER_BASE_URL}latest/index.js`;
export function WhitehallVisualizerEmbed() {
  useEffect(() => {
    if (!document.getElementById('whitehall-visualizer-css')) {
      const stylesheet = document.createElement('link');
      stylesheet.id = 'whitehall-visualizer-css';
      stylesheet.rel = 'stylesheet';
      stylesheet.href = VISUALIZER_CSS_URL;
      document.head.appendChild(stylesheet);
    }
    if (!document.querySelector('meta[data-whitehall-visualizer-origin="true"]')) {
      const meta = document.createElement('meta');
      meta.httpEquiv = 'Access-Control-Allow-Origin';
      meta.content = VISUALIZER_BASE_URL;
      meta.dataset.whitehallVisualizerOrigin = 'true';
      document.head.appendChild(meta);
    }
    if (!document.getElementById('whitehall-visualizer-js')) {
      const script = document.createElement('script');
      script.id = 'whitehall-visualizer-js';
      script.type = 'module';
      script.src = VISUALIZER_SCRIPT_URL;
      document.body.appendChild(script);
    }
  }, []);
  return <>
      <style data-id="element-773">{`
        #whitehall-root,
        #whitehall-root > *,
        #whitehall-root button,
        #whitehall-root [role="button"] {
          box-sizing: border-box !important;
          max-width: 100% !important;
          min-width: 0 !important;
        }

        #whitehall-root button,
        #whitehall-root [role="button"] {
          width: 100% !important;
          white-space: normal !important;
          overflow-wrap: anywhere !important;
        }
      `}</style>
      <div id="whitehall-root" className="w-full max-w-full min-w-0" style={{
      width: '100%',
      maxWidth: '100%',
      minWidth: 0
    }} display-type="button" item-code="2657BG" open-button-text="Preview Personalization in Whitehall Visualizer" title-text="Preview side plaque lettering" subtitle-text="Use this visual reference to explore lettering on the Whitehall mailbox side plaque." submit-button-text="Preview complete" submission-notice="This preview does not transfer text to the order form. Enter the final personalization in the required side-panel field before adding to cart." data-id="element-774">
        Preview Personalization in Whitehall Visualizer
      </div>
    </>;
}